import { mapMutations } from 'vuex';
import constants from '@/constants';
import i18n from '@/plugins/i18n';

export default {
  methods: {
    ...mapMutations(['setAppDialog']),

    showAppConfirmDialog({
      message,
      color,
      confirmText,
      confirmHandler,
      cancelText,
      cancelHandler,
    }) {
      this.setAppDialog({
        confirm: true,
        message,
        color: color || constants.AppColors.PRIMARY,
        confirmText: confirmText || i18n.t('actions.confirm'),
        confirmHandler,
        cancelText: cancelText || i18n.t('actions.cancel'),
        cancelHandler,
      });
    },

    showAppWarningDialog({ message }) {
      this.setAppDialog({
        warn: true,
        message,
      });
    },

    showAppErrorDialog({ message }) {
      this.setAppDialog({
        error: true,
        message,
      });
    },
  },
};
